// API Configuration
// Easy switching between local development and production

// ===== CONFIGURATION OPTIONS =====

// Option 1: Use local API (for development/testing)
const USE_LOCAL_API = false;  // Set to true for local testing, false for production

// ===== API ENDPOINTS =====

// Local development API
const LOCAL_API_URL = 'http://localhost:8001';

// Production API (your deployed API)
const PRODUCTION_API_URL = 'https://wow-pizza-api.onrender.com';

// ===== CONFIGURATION LOGIC =====

let API_BASE_URL;

if (USE_LOCAL_API) {
  API_BASE_URL = LOCAL_API_URL;
} else {
  API_BASE_URL = '';
}

export default API_BASE_URL;

export const API_URLS = {
  LOCAL: LOCAL_API_URL,
  PRODUCTION: PRODUCTION_API_URL,
  CURRENT: API_BASE_URL
};
